import styled from 'styled-components'

const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: auto;
	height: 100%;
`

export { Container }
